import { PartType } from '@/partTypes'

const MAX_CACHE_SIZE = 200
const rawPlankCache = new Map<string, PartType>()

export function setCachedRawPlank(partUniqueId: string, data: PartType) {
  if (rawPlankCache.has(partUniqueId)) return
  if (rawPlankCache.size >= MAX_CACHE_SIZE) {
    const firstKey = rawPlankCache.keys().next().value
    if (firstKey !== undefined) {
      rawPlankCache.delete(firstKey)
    }
  }
  rawPlankCache.set(partUniqueId, JSON.parse(JSON.stringify(data)))
}

export function getCachedRawPlank(partUniqueId: string): PartType | undefined {
  return rawPlankCache.get(partUniqueId)
}

export function clearCachedRawPlank() {
  rawPlankCache.clear()
}
